<!-- For Web View -->
<div class="inspection-category-item d-flex width-100p pt-2 pb-2 inspection-web-view">
  <div class="flex-start-center inspection-item-title">
    <p class="inspection-title m-0 font-600">
      {{ inspectionItem?.title }} 
    </p>
  </div>
  <div class="inspection-item-condition flex-between-center">
    <div class="flex-start-center position-relative" [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }">
      <div [ngClass]="{ 'disabled-radio': isArchived }"></div>
      <a href="javascript:void(0)" class="inline-block p-1"
        [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 0)">
        <div class="inspection-item-color good-hover" [ngClass]="{ good: inspectionItem?.colorIndex === 0 }"></div>
      </a>

      <a href="javascript:void(0)" class="inline-block p-1"
        [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 1)">
        <div class="inspection-item-color normal-hover" [ngClass]="{ normal: inspectionItem?.colorIndex === 1 }"></div>
      </a>

      <a href="javascript:void(0)" class="inline-block p-1"
        [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 2)">
        <div class="inspection-item-color bad-hover" [ngClass]="{ bad: inspectionItem?.colorIndex === 2 }"></div>
      </a>
    </div>

    <div [hidden]="inspectionItem.colorIndex <= -1 || !addMediaToInspectionEnabled"
      class="attachment-action-wrapper flex-start-center" [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }">
      <!-- Image attatchments -->
      <app-content-overlay right="-73px" [closeOnClickOutside]="true" [showArrow]="true" top="26px" arrowTop="-10px"
        arrowLeft="80%" arrowRight="75%">
        <ng-template appTemplate="item">
          <a href="javascript:void(0)" class="mr-4"
            [ngClass]="{ 'img-uploaded': isUploaded(inspectionItem?.attachments, 'image'), 'img-state': workStatus === 'inprogress' }">
            <i class="fal fa-image" (click)="handleAttachment()"></i>
          </a>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="invoice-date-change-overlay dynamic-height">
            <div *ngIf="!isUploaded(inspectionItem?.attachments, 'image')" class="no-image">
              <p>No images attached.</p>
            </div>
            <div *ngIf="inspectionItem?.attachments?.length" class="inspection-item-attachments h-100 overflow-auto">
              <div class="flex-start-center flex-wrap inpection-media-wrapper">
                <div *ngFor="let attachment of inspectionItem?.attachments; let attachmentIndex = index" class="br-3">
                  <div *ngIf="attachment.type === 'image'" class="inspection-media flex-center-center ml-1 mt-1">
                    <i (click)="deleteImage(attachmentIndex)" *ngIf="isEditMode" class="delete-media fal fa-trash"
                      [ngClass]="{ 'd-none': isArchived }"></i>
                    <i class="fal fa-search-plus image-zoom pointer"
                      (click)="openImagePreview(inspectionItem?.attachments, 'image', attachment)"></i>
                    <div class="attachment-fg-overlay"
                      (click)="openImagePreview(inspectionItem?.attachments, 'image', attachment)"></div>
                    <i class="fas fa-trash delete-icon pointer" (click)="deleteAttachment(attachmentIndex)"
                      [ngClass]="{ 'not-allowed': workStatus === 'inprogress', 'd-none': isArchived }"></i>
                    <img [src]="attachment.url" *ngIf="attachment.url" class="inspection-item-image" alt=""
                      (click)="openImagePreview(inspectionItem?.attachments, 'image', attachment)" />
                  </div>
                </div>
                <div *ngIf="isUploading" class="inspection-media flex-center-center ml-1 mt-1">
                  <i class="fal fa-spinner rotate"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-date-footer flex-end-center mt-2 pt-2 pr-2 pl-2 border-top">
            <button class="btn btn-white btn-50 font-12 text-center mr-1" (click)="close()">Cancel</button>
            <button class="btn btn-primary btn-50 font-12 text-center"
              [disabled]="workStatus === 'inprogress' || isArchived"
              [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
              (click)="handleBrowse(fileUpload)">
              Add
            </button>
          </div>
          <input type="file" (click)="fileUpload.value = ''; fileUpload.click()" class="d-none" accept="image/*"
            (change)="uploadFile($event)" #fileUpload />
        </ng-template>
      </app-content-overlay>

      <!-- Video attatchments -->
      <app-content-overlay right="-73px" [closeOnClickOutside]="true" [showArrow]="true" top="26px" arrowTop="-10px"
        arrowLeft="80%" arrowRight="75%">
        <ng-template appTemplate="item">
          <a href="javascript:void(0)" class="mr-4"
            [ngClass]="{ 'video-uploaded': isUploaded(inspectionItem?.attachments, 'video'), 'video-state': workStatus === 'inprogress' }">
            <i class="fal fa-video" (click)="handleAttachment()"></i>
          </a>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="invoice-date-change-overlay dynamic-height">
            <div *ngIf="!isUploaded(inspectionItem?.attachments, 'video')" class="no-video">
              <p>No video attached.</p>
            </div>

            <div *ngIf="inspectionItem?.attachments?.length" class="inspection-item-attachments h-100 overflow-auto">
              <div class="flex-start-center flex-wrap inpection-media-wrapper">
                <div *ngFor="let attachment of inspectionItem?.attachments; let attachmentIndex = index" class="br-3">
                  <div *ngIf="attachment.type === 'video'" class="inspection-media flex-center-center ml-1 mt-1">
                    <i (click)="deleteImage(attachmentIndex)" *ngIf="isEditMode" class="delete-media fal fa-trash"
                      [ngClass]="{ 'd-none': isArchived }"></i>
                    <i class="fal fa-play video-zoom pointer"
                      (click)="openImagePreview(inspectionItem?.attachments, 'video', attachment)"></i>
                    <div class="attachment-fg-overlay" (click)="openImagePreview(inspectionItem?.attachments, 'video')">
                    </div>
                    <i class="fas fa-trash delete-icon pointer"
                      (click)="deleteAttachment(attachmentIndex)"
                      [ngClass]="{ 'not-allowed': workStatus === 'inprogress', 'd-none': isArchived }"></i>
                    <video class="inspection-item-video" *ngIf="attachment.url"
                      (click)="openImagePreview(inspectionItem?.attachments, 'video', attachment)">
                      <source [src]="attachment.url" type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div *ngIf="isUploading" class="inspection-media flex-center-center ml-1 mt-1">
                  <i class="fal fa-spinner rotate"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="invoice-date-footer flex-end-center mt-2 pt-2 pr-2 pl-2 border-top">
            <button class="btn btn-white btn-50 font-12 text-center mr-1" (click)="close()">Cancel</button>
            <button class="btn btn-primary btn-50 font-12 text-center"
              [disabled]="workStatus === 'inprogress' || isArchived"
              [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
              (click)="handleBrowse(videoUpload)">
              Add
            </button>
          </div>

          <input (click)="videoUpload.value = ''; videoUpload.click()" type="file" class="d-none" accept="video/*"
            (change)="uploadVideoFile($event)" #videoUpload />
        </ng-template>
      </app-content-overlay>

      <!-- Voice attatchments -->
      <app-content-overlay right="-100px" [closeOnClickOutside]="true" [showArrow]="true" top="26px" arrowTop="-10px"
        [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }" arrowLeft="80%">
        <ng-template appTemplate="item">
          <a href="javascript:void(0)"
            [ngClass]="{ 'voice-uploaded': isUploaded(inspectionItem?.attachments, 'voice'), 'recording-state': workStatus === 'inprogress' }">
            <i class="fal fa-volume" (click)="handleAttachment()"></i>
          </a>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close">
          <div class="invoice-date-change-overlay dynamic-height overflow-auto">
            <div *ngIf="!isUploaded(inspectionItem?.attachments, 'voice')" class="no-image">
              <p>No audio recordings attached.</p>
            </div>
            <div *ngIf="inspectionItem?.attachments?.length" class="inspection-item-attachments">
              <div class="flex-start-center flex-wrap inpection-media-wrapper">
                <div *ngFor="let attachment of inspectionItem?.attachments; let attachmentIndex = index"
                  class="br-3 w-100">
                  <div *ngIf="attachment.type === 'voice'"
                    class="inspection-media flex-column flex-center-center voice-media-wrapper">
                    <div class="voice-media-row mb-1">
                      <div [hidden]="!attachment.isPlaying" class="inspection-media flex-column flex-center-center"
                        (click)="pauseAudio(attachment, attachmentIndex)">
                        <i class="fas fa-pause font-bold text-white"></i>
                      </div>
                      <div [hidden]="attachment.isPlaying" class="inspection-media flex-column flex-center-center"
                        (click)="playAudio(attachment, attachmentIndex)">
                        <i class="fas fa-play text-white"></i>
                      </div>
                      <div class="progress-bar-wrapper">
                        <span *ngIf="!attachment.isPlaying" class="progress-text">
                          00:00 11/
                          {{ renderRecordingTime(attachment.recordingTime) }}
                        </span>
                        <span *ngIf="attachment.isPlaying" class="progress-text">
                          {{ renderRecordingTime(playingTime) }} /
                          {{ renderRecordingTime(attachment.recordingTime) }}
                        </span>
                        <div class="progress-bar-placeholder">
                          <div *ngIf="attachment.isPlaying" class="progress-bar"
                            [ngStyle]="{ width: (playingTime / attachment.recordingTime) * 100 + '%' }"></div>
                        </div>
                        <span class="progress-text progress-date"
                          [pTooltip]="'from ' + attachment.createdBy + ' on ' + attachment.createdAtTz">
                          from {{ attachment.createdBy }} on {{ attachment.createdAtTz }}
                        </span>
                      </div>
                      <div class="right-buttons align-self-center text-right">
                        <i (click)="deleteAttachment(attachmentIndex)" class="fas fa-trash"
                          [ngClass]="{ 'not-allowed': workStatus === 'inprogress', 'd-none': isArchived }"></i>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isUploading" class="inspection-media flex-center-center mr-2 mt-2">
                    <i class="fal fa-spinner rotate"></i>
                  </div>
                  <!-- Invoice upload end -->
                </div>
              </div>
            </div>
            <div class="attachment-overlay-wrapper">
              <div class="inspection-attachment-overlay">
                <div class="inspection-attachment">
                  <div class="inspection-attachment-section p-0">
                    <div [hidden]="!isRecording && !isProcessing" class="p-2 flex-between-center inspection-item-media">
                      <div class="color flex-start-center">
                        <i class="fal fa-microphone font-14 font-bold font-error mr-2"></i>
                        <span class="font-12">
                          {{ renderRecordingTime() }}
                        </span>
                      </div>
                      <div class="flex-end-center">
                        <span class="font-primary font-12 mr-2 pointer" (click)="stopRecording(false)">Cancel</span>
                        <span class="font-primary font-12 pointer" (click)="stopRecording(true)">
                          <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
                          <i [hidden]="!isProcessing" class="fal fa-spinner rotate"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="invoice-date-footer flex-end-center mt-2 pt-2 pr-2 pl-2 border-top">
            <button class="btn btn-white btn-50 font-12 text-center mr-1" (click)="close()">Cancel</button>
            <button class="btn btn-primary btn-50 font-12 text-center"
              [disabled]="workStatus === 'inprogress' || isArchived"
              [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
              (click)="recordVoice()">
              Add
            </button>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
  </div>

  <div [hidden]="inspectionItem.colorIndex <= -1" class="inspection-item-notes md-screen"
    [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer' }">
    <app-textarea theme="light" styleClass="pt-0" placeholder="Add note" #textAreaRef [maxLength]="500"
      [disabled]="workStatus === 'inprogress' || isArchived" [value]="inspectionItem?.notes" [autoGrow]="true"
      [hasBorderBottomOnActive]="false" [maxAutoGrowHeight]="111" [textAreaId]="'notes' + inspectionItem?._id"
      (appChange)="handleChange('notes', $event)" (appFocus)="handleFocusChange('notes', true)"
      (appBlur)="handleFocusChange('notes', false)"></app-textarea>
  </div>

  <div [hidden]="inspectionItem.colorIndex <= -1 || !isDVICannedNotesEnabled" class="mt-2 md-screen">
    <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="true" right="-5%"
      (appHide)="openCannedNotes()" (appShow)="openCannedNotes()" [disabled]="cannedNotes.length === 0">
      <ng-template appTemplate="item">
        <div class="add-canned-notes" [ngClass]="cannedNotes.length === 0 && 'disabled-canned-notes'">
          <span>Canned notes</span>
          <i class="flex-center-center fa mt-1" [ngClass]="[!closeAfterAction ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </div>
      </ng-template>

      <ng-template appTemplate="overlay">
        <div class="filter-overlay w-403">
          <div class="filter-option border-bottom-lightest" (click)="onChange(notes)" *ngFor="let notes of cannedNotes">
            <app-checkbox [isChecked]="notes.isChecked" tooltipIconPosition="left" [tooltip]="notes.note">
            </app-checkbox>
            {{ notes.note }}
          </div>
        </div>
        <div class="canned-notes-footer flex-between-center w-403" *ngIf="!isLoadingNotes && cannedNotes?.length > 0">
          <div class="pointer" (click)="handleClearNotes()">Clear Selection</div>
          <div class="pointer" (click)="handleAddNotes()">Add {{ checkNotesLength() }} notes</div>
        </div>
      </ng-template>
    </app-content-overlay>
  </div>
</div>

<!-- For Mobile View -->
<div class="inspection-category-item d-flex width-100p pt-2 inspection-mobile-view">
  <div class="d-flex">
    <div class="flex-start-center inspection-item-title">
      <p class="inspection-title m-0 font-600">
        {{ inspectionItem?.title }}
      </p>
    </div>

    <div class="inspection-item-condition flex-between-center">
      <div class="flex-start-center position-relative" [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }">
        <div [ngClass]="{ 'disabled-radio': isArchived }"></div>
        <a href="javascript:void(0)" class="inline-block p-1"
          [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 0)">
          <div class="inspection-item-color good-hover" [ngClass]="{ good: inspectionItem?.colorIndex === 0 }"></div>
        </a>

        <a href="javascript:void(0)" class="inline-block p-1"
          [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 1)">
          <div class="inspection-item-color normal-hover" [ngClass]="{ normal: inspectionItem?.colorIndex === 1 }">
          </div>
        </a>

        <a href="javascript:void(0)" class="inline-block p-1"
          [ngClass]="{ 'inspection-state': workStatus === 'inprogress' }" (click)="handleChange('colorIndex', 2)">
          <div class="inspection-item-color bad-hover" [ngClass]="{ bad: inspectionItem?.colorIndex === 2 }"></div>
        </a>
      </div>
    </div>
  </div>

  <div class="d-flex">
    <div class="inspection-item-condition flex-between-center mobile-width-33"
      [hidden]="inspectionItem.colorIndex <= -1 || !addMediaToInspectionEnabled">
      <div class="attachment-action-wrapper flex-start-center"
        [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }">
        <!-- Image attatchments -->
        <app-content-overlay right="-170px" [closeOnClickOutside]="true" [showArrow]="true" top="26px" arrowTop="-10px"
          arrowLeft="80%" arrowRight="75%">
          <ng-template appTemplate="item">
            <a href="javascript:void(0)" class="mr-4"
              [ngClass]="{ 'img-uploaded': isUploaded(inspectionItem?.attachments, 'image'), 'img-state': workStatus === 'inprogress' }">
              <i class="fal fa-image" (click)="handleAttachment()"></i>
            </a>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close">
            <div class="invoice-date-change-overlay dynamic-height">
              <div *ngIf="!isUploaded(inspectionItem?.attachments, 'image')" class="no-image">
                <p>No images attached.</p>
              </div>
              <div *ngIf="inspectionItem?.attachments?.length" class="inspection-item-attachments h-100 overflow-auto">
                <div class="flex-start-center flex-wrap inpection-media-wrapper">
                  <div *ngFor="let attachment of inspectionItem?.attachments; let attachmentIndex = index" class="br-3">
                    <div *ngIf="attachment.type === 'image'" class="inspection-media flex-center-center ml-1 mt-1">
                      <i (click)="deleteImage(attachmentIndex)" *ngIf="isEditMode" class="delete-media fal fa-trash"
                        [ngClass]="{ 'd-none': isArchived }"></i>
                      <i class="fal fa-search-plus image-zoom pointer"
                        (click)="openImagePreview(inspectionItem?.attachments, 'image', attachment)"></i>
                      <div class="attachment-fg-overlay"
                        (click)="openImagePreview(inspectionItem?.attachments, 'image', attachment)"></div>
                      <i class="fas fa-trash delete-icon pointer" (click)="deleteAttachment(attachmentIndex)"
                        [ngClass]="{ 'not-allowed': workStatus === 'inprogress', 'd-none': isArchived }"></i>
                      <img [src]="attachment.url" *ngIf="attachment.url" class="inspection-item-image" alt=""
                        (click)="openImagePreview(inspectionItem?.attachments, 'image', attachment)" />
                    </div>
                  </div>
                  <div *ngIf="isUploading" class="inspection-media flex-center-center ml-1 mt-1">
                    <i class="fal fa-spinner rotate"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="invoice-date-footer flex-end-center mt-2 pt-2 pr-2 pl-2 border-top">
              <button class="btn btn-white btn-50 font-12 text-center mr-1" (click)="close()">Cancel</button>
              <button class="btn btn-primary btn-50 font-12 text-center"
                [disabled]="workStatus === 'inprogress' || isArchived"
                [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
                (click)="handleBrowse(fileUpload)">
                Add
              </button>
            </div>
            <input type="file" (click)="fileUpload.value = ''; fileUpload.click()" class="d-none" accept="image/*"
              (change)="uploadFile($event)" #fileUpload />
          </ng-template>
        </app-content-overlay>

        <!-- Video attatchments -->
        <app-content-overlay right="-170px" [closeOnClickOutside]="true" [showArrow]="true" top="26px" arrowTop="-10px"
          arrowLeft="80%" arrowRight="75%">
          <ng-template appTemplate="item">
            <a href="javascript:void(0)" class="mr-4"
              [ngClass]="{ 'video-uploaded': isUploaded(inspectionItem?.attachments, 'video'), 'video-state': workStatus === 'inprogress' }">
              <i class="fal fa-video" (click)="handleAttachment()"></i>
            </a>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close">
            <div class="invoice-date-change-overlay dynamic-height">
              <div *ngIf="!isUploaded(inspectionItem?.attachments, 'video')" class="no-video">
                <p>No video attached.</p>
              </div>

              <div *ngIf="inspectionItem?.attachments?.length" class="inspection-item-attachments h-100 overflow-auto">
                <div class="flex-start-center flex-wrap inpection-media-wrapper">
                  <div *ngFor="let attachment of inspectionItem?.attachments; let attachmentIndex = index" class="br-3">
                    <div *ngIf="attachment.type === 'video'" class="inspection-media flex-center-center ml-1 mt-1">
                      <i (click)="deleteImage(attachmentIndex)" *ngIf="isEditMode" class="delete-media fal fa-trash"
                        [ngClass]="{ 'd-none': isArchived }"></i>
                      <i class="fal fa-play video-zoom pointer"
                        (click)="openImagePreview(inspectionItem?.attachments, 'video', attachment)"></i>
                      <div class="attachment-fg-overlay"
                        (click)="openImagePreview(inspectionItem?.attachments, 'video')">
                      </div>
                      <i class="fas fa-trash delete-icon pointer" [ngClass]="{ 'd-none': isArchived }"
                        (click)="deleteAttachment(attachmentIndex)"
                        [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }"></i>
                      <video class="inspection-item-video" *ngIf="attachment.url"
                        (click)="openImagePreview(inspectionItem?.attachments, 'video', attachment)">
                        <source [src]="attachment.url" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                  <div *ngIf="isUploading" class="inspection-media flex-center-center ml-1 mt-1">
                    <i class="fal fa-spinner rotate"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="invoice-date-footer flex-end-center mt-2 pt-2 pr-2 pl-2 border-top">
              <button class="btn btn-white btn-50 font-12 text-center mr-1" (click)="close()">Cancel</button>
              <button class="btn btn-primary btn-50 font-12 text-center"
                [disabled]="workStatus === 'inprogress' || isArchived"
                [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
                (click)="handleBrowse(videoUpload)">
                Add
              </button>
            </div>

            <input (click)="videoUpload.value = ''; videoUpload.click()" type="file" class="d-none" accept="video/*"
              (change)="uploadVideoFile($event)" #videoUpload />
          </ng-template>
        </app-content-overlay>

        <!-- Voice attatchments -->
        <app-content-overlay right="-170px" [closeOnClickOutside]="true" [showArrow]="true" top="26px" arrowTop="-10px"
          [ngClass]="{ 'not-allowed': workStatus === 'inprogress' }" arrowLeft="80%">
          <ng-template appTemplate="item">
            <a href="javascript:void(0)"
              [ngClass]="{ 'voice-uploaded': isUploaded(inspectionItem?.attachments, 'voice'), 'recording-state': workStatus === 'inprogress' }">
              <i class="fal fa-volume" (click)="handleAttachment()"></i>
            </a>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close">
            <div class="invoice-date-change-overlay dynamic-height overflow-auto">
              <div *ngIf="!isUploaded(inspectionItem?.attachments, 'voice')" class="no-image">
                <p>No audio recordings attached.</p>
              </div>
              <div *ngIf="inspectionItem?.attachments?.length" class="inspection-item-attachments">
                <div class="flex-start-center flex-wrap inpection-media-wrapper">
                  <div *ngFor="let attachment of inspectionItem?.attachments; let attachmentIndex = index"
                    class="br-3 w-100">
                    <div *ngIf="attachment.type === 'voice'"
                      class="inspection-media flex-column flex-center-center voice-media-wrapper">
                      <div class="voice-media-row mb-1">
                        <div [hidden]="!attachment.isPlaying" class="inspection-media flex-column flex-center-center"
                          (click)="pauseAudio(attachment, attachmentIndex)">
                          <i class="fas fa-pause font-bold text-white"></i>
                        </div>
                        <div [hidden]="attachment.isPlaying" class="inspection-media flex-column flex-center-center"
                          (click)="playAudio(attachment, attachmentIndex)">
                          <i class="fas fa-play text-white"></i>
                        </div>
                        <div class="progress-bar-wrapper">
                          <span *ngIf="!attachment.isPlaying" class="progress-text">
                            00:00 /
                            {{ renderRecordingTime(attachment.recordingTime) }}
                          </span>
                          <span *ngIf="attachment.isPlaying" class="progress-text">
                            {{ renderRecordingTime(playingTime) }} /
                            {{ renderRecordingTime(attachment.recordingTime) }}
                          </span>
                          <div class="progress-bar-placeholder">
                            <div *ngIf="attachment.isPlaying" class="progress-bar"
                              [ngStyle]="{ width: (playingTime / attachment.recordingTime) * 100 + '%' }"></div>
                          </div>
                          <span class="progress-text progress-date"
                            [pTooltip]="'from ' + attachment.createdBy + ' on ' + attachment.createdAtTz">
                            from {{ attachment.createdBy }} on {{ attachment.createdAtTz }}
                          </span>
                        </div>
                        <div class="right-buttons align-self-center text-right">
                          <i (click)="deleteAttachment(attachmentIndex)" class="fas fa-trash"
                            [ngClass]="{ 'not-allowed': workStatus === 'inprogress', 'd-none': isArchived }"></i>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isUploading" class="inspection-media flex-center-center mr-2 mt-2">
                      <i class="fal fa-spinner rotate"></i>
                    </div>
                    <!-- Invoice upload end -->
                  </div>
                </div>
              </div>
              <div class="attachment-overlay-wrapper">
                <div class="inspection-attachment-overlay">
                  <div class="inspection-attachment">
                    <div class="inspection-attachment-section p-0">
                      <div [hidden]="!isRecording && !isProcessing"
                        class="p-2 flex-between-center inspection-item-media">
                        <div class="color flex-start-center">
                          <i class="fal fa-microphone font-14 font-bold font-error mr-2"></i>
                          <span class="font-12">
                            {{ renderRecordingTime() }}
                          </span>
                        </div>
                        <div class="flex-end-center">
                          <span class="font-primary font-12 mr-2 pointer" (click)="stopRecording(false)">Cancel</span>
                          <span class="font-primary font-12 pointer" (click)="stopRecording(true)">
                            <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
                            <i [hidden]="!isProcessing" class="fal fa-spinner rotate"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="invoice-date-footer flex-end-center mt-2 pt-2 pr-2 pl-2 border-top">
              <button class="btn btn-white btn-50 font-12 text-center mr-1" (click)="close()">Cancel</button>
              <button class="btn btn-primary btn-50 font-12 text-center"
                [disabled]="workStatus === 'inprogress' || isArchived"
                [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer', 'z-index': 99 }"
                (click)="recordVoice()">
                Add
              </button>
            </div>
          </ng-template>
        </app-content-overlay>
      </div>
    </div>

    <div [hidden]="inspectionItem.colorIndex <= -1" class="inspection-item-notes width-0 mobile-width-33 md-screen"
      [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer' }">
      <app-textarea theme="light" styleClass="pt-0" placeholder="Add note" #textAreaRef [maxLength]="500"
        [disabled]="workStatus === 'inprogress' || isArchived" [value]="inspectionItem?.notes" [autoGrow]="true"
        [hasBorderBottomOnActive]="false" [maxAutoGrowHeight]="111" [textAreaId]="'notes' + inspectionItem?._id"
        (appChange)="handleChange('notes', $event)" (appFocus)="handleFocusChange('notes', true)"
        (appBlur)="handleFocusChange('notes', false)"></app-textarea>
    </div>

    <div [hidden]="inspectionItem.colorIndex <= -1 || !isDVICannedNotesEnabled" class="flex-between-center md-screen">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="true" right="-5%"
        (appHide)="openCannedNotes()" (appShow)="openCannedNotes()" [disabled]="cannedNotes.length === 0">
        <ng-template appTemplate="item">
          <div class="add-canned-notes" [ngClass]="cannedNotes.length === 0 && 'disabled-canned-notes'">
            <span>Canned notes</span>
            <i class="flex-center-center fa mt-1" [ngClass]="[!closeAfterAction ? 'fa-angle-up' : 'fa-angle-down']"></i>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-403">
            <div class="filter-option border-bottom-lightest" (click)="onChange(notes)"
              *ngFor="let notes of cannedNotes">
              <app-checkbox [isChecked]="notes.isChecked" tooltipIconPosition="left" [tooltip]="notes.note">
              </app-checkbox>
              {{ notes.note }}
            </div>
          </div>
          <div class="canned-notes-footer flex-between-center w-403" *ngIf="!isLoadingNotes && cannedNotes?.length > 0">
            <div class="pointer" (click)="handleClearNotes()">Clear Selection</div>
            <div class="pointer" (click)="handleAddNotes()">Add {{ checkNotesLength() }} notes</div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
  </div>

  <div class="d-flex" *ngIf="screenWidth < 540">
    <div [hidden]="inspectionItem.colorIndex <= -1" class="inspection-item-notes width-0 mobile-width-33"
      [ngStyle]="{ cursor: workStatus === 'inprogress' ? 'not-allowed' : 'pointer' }">
      <app-textarea theme="light" styleClass="pt-0 p-0" placeholder="Add note" #textAreaRef [maxLength]="500"
        [disabled]="workStatus === 'inprogress' || isArchived" [value]="inspectionItem?.notes" [autoGrow]="true"
        [hasBorderBottomOnActive]="false" [maxAutoGrowHeight]="111" [textAreaId]="'notes' + inspectionItem?._id"
        (appChange)="handleChange('notes', $event)" (appFocus)="handleFocusChange('notes', true)"
        (appBlur)="handleFocusChange('notes', false)"></app-textarea>
    </div>

    <div [hidden]="inspectionItem.colorIndex <= -1 || !isDVICannedNotesEnabled" class="flex-between-center">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="true" right="-30%"
        (appHide)="openCannedNotes()" (appShow)="openCannedNotes()" [disabled]="cannedNotes.length === 0">
        <ng-template appTemplate="item">
          <div class="add-canned-notes" [ngClass]="cannedNotes.length === 0 && 'disabled-canned-notes'">
            <span>Canned notes</span>
            <i class="flex-center-center fa mt-1" [ngClass]="[!closeAfterAction ? 'fa-angle-up' : 'fa-angle-down']"></i>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-295">
            <div class="filter-option border-bottom-lightest" (click)="onChange(notes)"
              *ngFor="let notes of cannedNotes">
              <app-checkbox [isChecked]="notes.isChecked" tooltipIconPosition="left" [tooltip]="notes.note">
              </app-checkbox>
              {{ notes.note }}
            </div>
          </div>
          <div class="canned-notes-footer flex-between-center w-295" *ngIf="!isLoadingNotes && cannedNotes?.length > 0">
            <div class="pointer" (click)="handleClearNotes()">Clear Selection</div>
            <div class="pointer" (click)="handleAddNotes()">Add {{ checkNotesLength() }} notes</div>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
  </div>

  <!-- <div class="text-area-border-bottom"></div> -->
</div>